import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import axios from 'axios'

const Temp = styled.p`
  text-align: center;
  padding-bottom: 1rem;
  font-size: 1rem;
`
class Weather extends Component {
  state = {
    temp: 0,
  }
  componentDidMount() {
    axios
      .get(
        'https://api.apixu.com/v1/current.json?key=55f78b49f858457097d162331181803&q=33713'
      )
      .then(response => {
        const roundedTemp = Math.round(response.data.current.temp_f)
        this.setState({ temp: roundedTemp })
      })
      .catch(error => {
        console.log(error)
      })
  }
  render() {
    const notZero = this.state.temp !== 0
    const message = notZero ? (
      <Temp>{this.state.temp}℉ in the Sunshine City! ☀️</Temp>
    ) : (
      <Temp>Comin' at ya from the Sunshine City! ☀️</Temp>
    )
    return <Fragment>{message}</Fragment>
  }
}

export default Weather



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Weather.js